import React from 'react';
import ReactDOM from 'react-dom';
import { getPortalContainer } from '../utils/domUtils';
import {
  PaymentDialogOverlay,
  PaymentDialog,
  PaymentDialogHeader,
  PaymentDialogTitle,
  CloseButtonModal,
  PaymentDialogContent,
  PaymentDialogFooter,
  CancelButton,
  SubmitButton
} from '../styled/Modals';

const PaymentWarningDialog = ({
  showPaymentWarning,
  setShowPaymentWarning,
  pendingPaymentLink
}) => {
  if (!showPaymentWarning) return null;

  const paymentDialogContainer = getPortalContainer('payment-warning-dialog-container');

  const handleProceedClick = () => {
    window.open(pendingPaymentLink, '_blank');
    setShowPaymentWarning(false);
  };

  return ReactDOM.createPortal(
    <PaymentDialogOverlay>
      <PaymentDialog style={{ maxWidth: '500px' }}>
        <PaymentDialogHeader>
          <PaymentDialogTitle>External Payment Confirmation</PaymentDialogTitle>
          <CloseButtonModal onClick={() => setShowPaymentWarning(false)}>✕</CloseButtonModal>
        </PaymentDialogHeader>
        <PaymentDialogContent>
          <div style={{ marginBottom: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
              <span style={{ fontSize: '24px', marginRight: '10px' }}>⚠️</span>
              <span style={{ fontSize: '16px', fontWeight: 'bold' }}>External Payment Warning</span>
            </div>
            <p style={{ marginBottom: '12px' }}>
              You are about to be redirected to an external payment system. Please note:
            </p>
            <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>iMaven Ai is not responsible for transactions conducted on external platforms.</li>
              <li style={{ marginBottom: '8px' }}>We cannot guarantee the security of external payment sites.</li>
              <li style={{ marginBottom: '8px' }}>Please ensure you trust this payment link before proceeding.</li>
              <li>Your data protection on external sites is subject to their privacy policies.</li>
            </ul>
            <p>
              If you have any concerns, please contact your advisor for alternative payment methods.
            </p>
          </div>
        </PaymentDialogContent>
        <PaymentDialogFooter>
          <CancelButton onClick={() => setShowPaymentWarning(false)}>Cancel</CancelButton>
          <SubmitButton onClick={handleProceedClick}>
            I Understand, Proceed
          </SubmitButton>
        </PaymentDialogFooter>
      </PaymentDialog>
    </PaymentDialogOverlay>,
    paymentDialogContainer
  );
};

export default PaymentWarningDialog; 